<template>
  <div class="rela-visitor-card">
    <template v-if="attributes.linkCommunicatePlanData">
      <div class="rela-visitor-card__title">关联访客计划</div>
      <div class="rela-visitor-card__rela">
        <div class="rela">
          <div class="rela__title">
            <i class="icon-sparkling-2-fill t-iconfont"></i>
            <span>助手为你推荐可关联访客计划</span>
          </div>
          <div class="rela__content">
            <VisitorCard :card-info="attributes.linkCommunicatePlanData"></VisitorCard>
          </div>
          <div v-if="!attributes.linkCommunicatePlanStatus" class="rela__footer">
            <button
              v-if="+attributes.linkCommunicateMultipleTag === 2"
              class="btn link-other-btn"
              @click="relyOtherCommunicatePlan"
            >
              <span class="btn-text">关联其他</span>
            </button>
            <button
              class="btn link-plan-btn"
              @click="relyCurrentCommunicatePlan(attributes.linkCommunicatePlanData)"
            >
              <span class="btn-text">确定关联</span>
            </button>
          </div>
          <div v-else class="rela__footer">
            <button class="btn link-plan-btn" style="opacity: 0.5">
              <span class="btn-text">已关联</span>
            </button>
          </div>
        </div>
      </div>
      <div v-if="isShowAiSuggest" class="cut-off"></div>
    </template>
    <template v-if="isShowAiSuggest">
      <div
        v-if="!inDetail ? targetList.length > 0 : aiRecommendPlan.length > 0"
        class="rela-visitor-card__title"
      >
        AI 推荐任务
      </div>
      <ChatRecommendCard
        :ai-recommend-plan="!inDetail ? targetList : aiRecommendPlan"
        @ignore="removeData"
        @toCreate="toCreate"
      ></ChatRecommendCard>
    </template>
    <div v-if="!attributes.linkCommunicatePlanData && !isShowAiSuggest" class="unenableSuggest">
      <img v-if="showChatbotImg" alt="AI助手logo" src="@/assets/chatbot.svg" />
      <div>
        <img alt="" :src="Flower" />
        <span>本次跟进中未发现未解决的事项，继续保持离成功越来越近了~</span>
        <img alt="" :src="Flower" />
      </div>
    </div>
    <!-- 关联访客计划web端弹窗 -->
    <el-dialog v-model="dialogVisible" class="new-style-dialog" title="关联访客计划" width="800">
      <div class="rela-dialog-content">
        <el-input
          v-model="searchName"
          clearable
          placeholder="搜索访客计划名称"
          :prefix-icon="Search"
          @input="handleSearchInput"
        >
        </el-input>
        <div v-for="(item, index) in CommunicatePlanList" :key="index">
          <VisitorCard
            :card-info="item"
            show-right-btn
            @rela="relyCurrentCommunicatePlan"
          ></VisitorCard>
        </div>
      </div>
    </el-dialog>
    <!-- 关联访客计划app端抽屉 -->
    <el-drawer
      v-model="drawerVisible"
      class="rela-drawer"
      direction="btt"
      size="80%"
      title="关联访客计划"
    >
      <div class="rela-drawer-content">
        <el-input
          v-model="searchName"
          clearable
          placeholder="搜索访客计划名称"
          :prefix-icon="Search"
          @input="handleSearchInput"
        >
        </el-input>
        <div v-for="(item, index) in CommunicatePlanList" :key="index">
          <VisitorCard
            :card-info="item"
            :show-memo="false"
            show-right-btn
            @rela="relyCurrentCommunicatePlan"
          ></VisitorCard>
        </div>
      </div>
    </el-drawer>
    <!-- 移动端新建访客计划容器 -->
    <AiUseXbbForm
      v-if="xbbUrl && showXbb"
      v-model:loading="iframeLoading"
      v-model:show-xbb="showXbb"
      :xbb-url="xbbUrl"
      @handleXbbSuccess="handleXbbSuccess"
    />
  </div>
</template>

<script setup>
import { ref, onMounted, computed, onBeforeUnmount } from 'vue'
import { Search } from '@element-plus/icons-vue'
import VisitorCard from '@/components/Cards/components/visitor-card.vue'
import { isMobile } from '@/utils'
import {
  getCustomRecordInfo,
  blindAddPlan,
  getCommunicatePlanList,
  relyCommunicatePlan
} from '@/api'
import xbbSdk from 'xbb-sdk'
import xbb from '@xbb/xbb-utils'
import Flower from '@/assets/flower.png'
import AiUseXbbForm from '@/components/ai-use-xbbform/index.vue'
import ChatRecommendCard from './components/recommend-card.vue'
import AppMessage from '@/components/message/index.js'
import { useAppStore } from '@/store/useAppStore'

defineOptions({
  name: 'RelaVisitorCard'
})
const emits = defineEmits(['refreshList', 'removeData'])
const props = defineProps({
  attributes: {
    type: Object,
    default: () => ({})
  },
  aiRecommendPlan: {
    type: Array,
    default: () => []
  },
  recommendTaskEnable: {
    type: Boolean,
    default: false
  },
  inDetail: {
    type: Boolean,
    default: false
  }
})

const sendXbbParams = ref({})
const dialogVisible = ref(false)
const drawerVisible = ref(false)
const searchName = ref('')
const CommunicatePlanList = ref([])
const timeout = ref(null)
const iframeLoading = ref(false)
const showXbb = ref(false)
const xbbUrl = ref('')
const detailId = ref('')

/**
 * 是否展示'AI助手logo'
 */
const showChatbotImg = computed(() => {
  return +props?.attributes?.assistantId !== 2
})

// targetList标识在跟进助手页面的推荐任务列表
const targetList = computed(() => props.attributes.targetList || [])

const isShowAiSuggest = computed(() => {
  return (
    (props.recommendTaskEnable && props.aiRecommendPlan.length > 0) || targetList.value.length > 0
  )
})

onMounted(() => {
  window.addEventListener('message', xbbIframeWeb)
})

onBeforeUnmount(() => {
  window.removeEventListener('message', xbbIframeWeb)
})

/**
 * 处理销帮帮成功回调 （web端）
 * @param e
 */
const xbbIframeWeb = (e) => {
  if (e.data?.type === 'aiSuccessWeb') {
    const params = e.data.data
    const result = e.data.result
    // 校验是否是当前表单 因为销帮帮可以关联新建
    if (
      params.appId === sendXbbParams.value.appId &&
      params.menuId === sendXbbParams.value.menuId &&
      params.formId === sendXbbParams.value.formId &&
      params.businessType === sendXbbParams.value.businessType &&
      +params.businessType === 601
    ) {
      blindAddPlan({
        detailId: detailId.value,
        communicatePlanId: result.dataId
      }).then(() => {
        if (targetList.value.length > 0 && !props.inDetail) {
          emits('refreshList') // 在会话页面直接刷新
        } else {
          removeData({ detailId: detailId.value })
        }
        detailId.value = ''
      })
    }
  }
}

const removeData = (plan) => {
  if (targetList.value.length > 0 && !props.inDetail) {
    emits('refreshList') // 在会话页面直接刷新
    return
  }
  // 找到数组aiRecommendPlan符合条件的数据，将数据从数组中移除。条件是，数组数据内，都有一个list数组，切长度恒为1.若list[0].detailId === detailId.value，则移除该数据
  const index = props.aiRecommendPlan.findIndex((item) => item.list[0].detailId === plan.detailId)
  if (index !== -1) {
    emits('removeData', index)
  }
}

/**
 * 处理销帮帮成功回调 （移动端）
 * @param e
 */
const handleXbbSuccess = (e) => {
  useAppStore().setIsXbbIframeShow(false)
  showXbb.value = false
  const params = e.data.params
  if (+params.businessType === 601) {
    AppMessage.success('新建成功')
    blindAddPlan({
      detailId: detailId.value,
      communicatePlanId: e.data.dataId
    }).then(() => {
      if (targetList.value.length > 0 && !props.inDetail) {
        emits('refreshList') // 在会话页面直接刷新
      } else {
        removeData({ detailId: detailId.value }) // 详情页 移除数据数组中的数据 避免刷新
      }
      detailId.value = ''
    })
  }
}

// 关联此访客计划
const relyCurrentCommunicatePlan = async (data) => {
  try {
    await relyCommunicatePlan({
      meetingExecuteStrategyId: props.attributes.meetingExecuteStrategyId,
      communicatePlanId: data.id,
      customerCommunicateId: props.attributes.linkCommunicatePlanData.customerCommunicateId
    })
    // eslint-disable-next-line vue/no-mutating-props
    props.attributes.linkCommunicatePlanStatus = 1
  } catch (error) {
    console.log('ERROR: ', error)
  } finally {
    dialogVisible.value = false
    drawerVisible.value = false
    emits('refreshList')
  }
}

// 关联其他访客计划
function relyOtherCommunicatePlan() {
  if (isMobile()) {
    drawerVisible.value = true
  } else {
    dialogVisible.value = true
  }
  getPlanList()
}

// 创建访客计划
async function toCreate(plan) {
  detailId.value = plan.detailId
  if (isMobile()) {
    iframeLoading.value = true
    const path = 'application/newForm'
    const res = await getParams(601)
    const { appId, menuId, formId, businessType, subBusinessType, frontUrl } = res
    const targetUrl = xbb.isDevEnv() ? 'http://localhost:8080/' : frontUrl
    xbbUrl.value = `${targetUrl}?isAi=1&useAiPosition=1&detailId=${
      detailId.value
    }#/${path}?appId=${appId}&menuId=${menuId}&formId=${formId}&saasMark=1&distributorMark=0&businessType=${businessType}&subBusinessType=${subBusinessType}&timestamp=${new Date().getTime()}&isAiRoot=1`
    showXbb.value = true
    useAppStore().setIsXbbIframeShow(true)
  } else {
    const params = await getParams(601)
    sendXbbParams.value = {
      appId: params.appId,
      menuId: params.menuId,
      formId: params.formId,
      saasMark: 1,
      businessType: params.businessType,
      subBusinessType: params.subBusinessType
    }
    xbbSdk.sendMessage('addNewForm', {
      appId: params.appId,
      menuId: params.menuId,
      formId: params.formId,
      saasMark: 1,
      businessType: params.businessType,
      subBusinessType: params.subBusinessType,
      detailId: detailId.value
    })
  }
}

// 获取访客计划列表
function getPlanList() {
  getCommunicatePlanList({
    nameLike: searchName.value,
    customerId: props.attributes.linkCommunicatePlanData.customerId,
    page: 1,
    pageSize: 100
  }).then(({ result }) => {
    CommunicatePlanList.value = result.data || []
  })
}

function handleSearchInput() {
  clearTimeout(timeout.value)
  timeout.value = setTimeout(() => {
    getPlanList()
  }, 500)
}

const getParams = async (type) => {
  const res = await getCustomRecordInfo({ businessType: type })
  const { appId, menuId, formId, businessType, subBusinessType, frontUrl } = res.result
  return { appId, menuId, formId, businessType, subBusinessType, frontUrl }
}
</script>

<style lang="less" scoped>
.rela-visitor-card {
  &__title {
    height: 20px;
    line-height: 20px;
    font-size: 14px;
    font-weight: 600;
    color: #323233;
    margin-bottom: 8px;
  }
  &__rela,
  &__suggest {
    background-color: #f7f8fa;
    border-radius: 8px;
    padding: 12px;
    .rela {
      &__title {
        height: 20px;
        line-height: 20px;
        font-size: 14px;
        color: #323233;
        margin-bottom: 12px;
        i {
          background: linear-gradient(314deg, #1574ff 2%, #5952ff 51%, #a969fe 96%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          text-fill-color: transparent;
          margin-right: 8px;
        }
      }
      &__content {
        margin-bottom: 12px;
      }
      &__footer {
        display: flex;
        flex-direction: row;
        .btn {
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          border: 1px solid;
          border-radius: 64px;
          padding: 8px 12px;
          background: transparent;
          cursor: pointer;

          &:nth-child(2) {
            margin-left: 12px;
          }
          .btn-text {
            font-size: 13px;
          }
        }

        .link-other-btn {
          border-color: #e5e6eb;

          .btn-text {
            color: #646566;
          }
        }
        .link-plan-btn {
          border-color: #7a52f4;
          .btn-text {
            color: #7a52f4;
          }
        }
      }
    }
    .suggest {
      &__title {
        display: flex;
        align-items: center;
        height: 20px;
        font-size: 14px;
        color: #323233;
        font-weight: 600;
        img {
          width: 20px;
          height: 20px;
          margin-right: 8px;
        }
      }
      &__content {
        margin: 8px 0 12px;
        padding: 8px;
        background: #f7f8fa;
        border-radius: 8px;
        font-size: 14px;
        color: #969799;
        ol {
          list-style-type: decimal !important;
          padding-left: 1rem !important;
          margin: 0.5rem 0 !important;
        }
        .item-title {
          margin-left: -1.5rem;
        }
        .empty {
          text-align: left;
          margin-left: -1rem;
        }
      }
      &__footer {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 36px;
        border-radius: 8px;
        background: #7a52f4;
        color: #fff;
        font-size: 14px;
      }
    }
  }
  .rela-visitor-card__empty {
    background: #f7f8fa;
    border-radius: 8px;
    padding: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      height: 20px;
      width: 27px;
    }
    span {
      margin: 0 12px;
      font-family: PingFang SC;
      font-size: 14px;
      line-height: 20px;
      color: #969799;
    }
  }
  .have-data-style {
    background-color: #fff;
    border: 1px solid #f2f3f5;
  }
  .cut-off {
    margin: 16px 0;
    border-top: 1px dashed #f2f3f5;
  }
  .empty {
    height: 20px;
    line-height: 20px;
    font-size: 14px;
    color: #969799;
    text-align: center;
  }
}
.rela-dialog-content {
  height: 580px;
  overflow: auto;
  .visitor-card {
    margin-bottom: 8px;
    &:first-child {
      margin-top: 16px;
    }
  }
}
:deep(.el-drawer) {
  border-radius: 20px 20px 0px 0px;
  .el-drawer__header {
    margin-bottom: 12px;
  }
  .el-drawer__title {
    text-align: center;
    color: #323233;
    font-size: 16px;
  }
  .rela-drawer-content {
    height: 100%;
    overflow-y: scroll;
    box-sizing: border-box;
    padding: 12px;
    .visitor-card {
      margin-bottom: 8px;
      &:first-child {
        margin-top: 16px;
      }
    }
  }
}
.unenableSuggest {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 12px 0;
  font-size: 14px;
  font-family: PingFang SC;
  color: #969799;
}
.is-show-limit {
  height: 288px;
  overflow: hidden;
  margin-bottom: 16px;
  position: relative;
  .show-more {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 52px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(180deg, rgba(247, 248, 250, 0) 0%, #f7f8fa 37%);
    .text {
      cursor: pointer;
      font-family: PingFang SC;
      font-size: 12px;
      line-height: 16px;
      color: #248df5;
    }
  }
}
</style>

<style lang="scss">
// 被文件 src/components/drawer-mobile/drawer-v2.vue 影响，先在这里再处理回去
.rela-drawer {
  .el-drawer__header {
    padding: 20px;
    padding-bottom: 0;
  }
}
</style>
